import styled from 'styled-components';

export const FlexSection = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  color: #eee;
`;

export const FlexCard = styled.div`
  width: 300px;
  text-align: center;
  cursor: pointer;
`;

export const FlexImage = styled.img`
  width: 100%;
  border-radius: 10px;
`;